import React, { useState, useMemo, useEffect } from "react";
import axios from "axios";
import { dbService } from "../../firebaseInstance";
// import { handleThreadsPopupLogin } from "../../utils/authUtils";
import { Box } from "@mui/material";
import LoginUserSection from "../../template/login/LoginUserSection";
import UspTemplate from "../../template/login/UspTemplate";
import { PageContainer } from "../Container/PageContainer";
import { Footer } from "../navigation/Footer";
import colors from "../../designTokens/colors.esm";
import { useResponsive } from "../../hooks/useResponsive";
// import { useLocation } from "react-router-dom";
// import FadeInContainer from "../patterns/motion/FadeInContainer";
import { useThreadsAuth } from "../../hooks/useThreadsAuth";
import { getProfilePure } from "../../utils/pureDataFetch";

 

const Login = () => {
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);
    const { isPC } = useResponsive();
    // const location = useLocation();

	// Threads 인증 훅 사용
	const { login: threadsLogin } = useThreadsAuth();

	// 테스트 모드: redirect 없이 로그인 결과만 콘솔 출력 (테스트 모드에서만 동작)
	useEffect(() => {
		// 테스트 모드 게이트
		let isTestMode = false;
		try {
			isTestMode = sessionStorage.getItem("login_test_mode") === "1";
		} catch (_) {}
		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.search);
		const state = params.get("state");
		if (!isTestMode && state !== "test") return;

		// 해시 프래그먼트 제거(#_ 방지) 후 파싱 + 즉시 루트로 replace
		url.hash = "";
		const code = params.get("code");
		if (!code || !state) return;
		window.history.replaceState({}, document.title, "/");

		// 같은 코드 재교환 방지
		try {
			const used = sessionStorage.getItem("oauth_code_used");
			if (used && used === code) {
				console.warn("⚠️ [TEST] Skipping exchange: code already used");
				return;
			}
			sessionStorage.setItem("oauth_code_used", code);
		} catch (_) {}

		// URL 정리: code/state 제거 (App의 콜백 강제 라우팅 방지)
		window.history.replaceState({}, document.title, "/");

		// 저장된 redirect_uri 사용(문자 단위 일치 보장)
		let redirectUri = `${window.location.origin}/`;
		try {
			const stored = sessionStorage.getItem("oauth_redirect_uri");
			if (stored) redirectUri = stored;
		} catch (_) {}

		// Threads 토큰 교환 (POST x-www-form-urlencoded)
		const clientId = "511936531788597";
		const clientSecret = "1e94ec81ac12344d576f2851834e7235";

		(async () => {
			try {
				console.log("🔗 [TEST] redirect_uri used:", redirectUri);
				const body = new URLSearchParams();
				body.append("client_id", clientId);
				body.append("client_secret", clientSecret);
				body.append("redirect_uri", redirectUri);
				body.append("code", code);
				body.append("grant_type", "authorization_code");
				let tokenResp;
				try {
					tokenResp = await axios.post(
						"https://graph.threads.net/oauth/access_token",
						body,
						{
							headers: {
								"Content-Type":
									"application/x-www-form-urlencoded; charset=UTF-8",
							},
						}
					);
				} catch (postErr) {
					console.warn(
						"POST exchange failed [TEST], falling back to GET",
						postErr
					);
					tokenResp = await axios.get(
						"https://graph.threads.net/oauth/access_token",
						{
							params: {
								client_id: clientId,
								client_secret: clientSecret,
								redirect_uri: redirectUri,
								code: code,
								grant_type: "authorization_code",
							},
						}
					);
				}
				const accessToken = tokenResp?.data?.access_token;
				console.log("🔑 [TEST] token response:", tokenResp?.data);
				if (!accessToken) return;
				const profile = await getProfilePure(accessToken);
				console.log("👤 [TEST] profile:", profile);
			} catch (e) {
				console.error("❌ [TEST] token exchange failed:", e);
			}
		})();
	}, []);

    // Lenis 스크롤 제거

	// 반응형 레이아웃 설정
	const responsiveLayout = useMemo(
		() => ({
			// 메인 컨테이너 패딩 - 실제 모바일에서 첫 번째 메시지 숨기기 위해 50vh로 증가
			paddingTop: isPC ? "10vh" : "10vh",

			// 스택 간격 조정 - 실제 모바일과 태블릿 구분
			mainSpacing: isPC ? { xs: 1.5, sm: 2.5, md: 3 } : { xs: 1, sm: 1.5 },
			innerSpacing: isPC ? { xs: 1, sm: 1.5 } : { xs: 0.5, sm: 1 },
		}),
		[isPC]
	);

	// 개선된 로그인 핸들러
	const handleLogin = async () => {
		try {
			console.log("🚀 팝업 기반 Threads 로그인 시작");
			await threadsLogin();
			console.log("✅ Threads 로그인 성공");

			// 로그인 성공 후 리다이렉트 또는 추가 작업
			// 예: 대시보드로 이동 등
		} catch (error) {
			console.error("❌ Threads 로그인 실패:", error);
			// 에러는 이미 useThreadsAuth에서 처리됨
		}
	};

	// 테스트 로그인 버튼: redirect 없이 Login으로 복귀해 콘솔만 출력
    // const handleTestLogin = () => { /* removed with Lenis cleanup */ };

	const handleWaitlist = async () => {
		if (!name || !email) return;

		setIsSubmitting(true);
		try {
			const waitlistRef = dbService.collection("waitlist").doc(name);
			await waitlistRef.set({
				name,
				email,
				createdAt: new Date().toISOString(),
			});

			setName("");
			setEmail("");
			alert("Successfully joined waitlist!");
		} catch (error) {
			console.error("Error adding to waitlist:", error);
			alert("Failed to join waitlist. Please try again.");
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<>
			{/* 배경 그라데이션 레이어 - fixed로 헤더까지 커버 */}
			<Box
				sx={{
					position: "fixed",
					top: 0,
					left: 0,
					width: "100%",
					height: "100vh",
					background: `
            linear-gradient(
              135deg, 
              ${colors.inkGray[1]} 0%, 
              ${colors.inkGray[1]} 60%, 
              ${colors.inkGray[2]} 85%, 
              ${colors.inkGray[3]} 100%
            )
          `,
					zIndex: -1, // 모든 컨텐츠 뒤에 배치
					pointerEvents: "none", // 마우스 이벤트 차단
				}}
			/>

			{/* 원래 Login 컨텐츠 */}
			<Box
				sx={{
					position: "relative",
					width: "100%",
					minHeight: "100vh",
					paddingTop: responsiveLayout.paddingTop, // 타이틀을 중앙에서 살짝 위로
				}}
			>
				<PageContainer>
					{/* <Stack
						direction="column"
						alignItems="center"
						justifyContent="center"
						spacing={responsiveLayout.mainSpacing}
						sx={{
							width: "100%",
						}}
					>
						<Stack
							direction="column"
							alignItems="center"
							spacing={responsiveLayout.innerSpacing}
							sx={{ width: "100%" }}
						>
							<Box sx={{ position: "relative", zIndex: 5, width: "100%" }}>
								<BrandVideoTemplate />
							</Box>
						</Stack>
					</Stack> */}

					{/* USP Template 추가 */}
					<Box
						data-usp-template="true"
						sx={{
							position: "relative",
							zIndex: 20,
							// marginTop: isMobile ? "30vh" : "0vh", // 모바일에서만 30vh 간격 추가
						}}
					>
						<UspTemplate />
					</Box>
					{/* LoginUserSection 직접 배치 */}
					<Box sx={{ position: "relative", zIndex: 20 }}>
						<LoginUserSection
							name={name}
							email={email}
							isSubmitting={isSubmitting}
							handleLogin={handleLogin}
							handleWaitlist={handleWaitlist}
							setName={setName}
							setEmail={setEmail}
						/>
					</Box>
				</PageContainer>

				{/* Footer - PageContainer 밖에 배치 */}
				<Box sx={{ position: "relative", zIndex: 20 }}>
					<Footer />
				</Box>
			</Box>
		</>
	);
};

export default Login;
